import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AlertField from "../Components/AlertField";
import InputField from "../Components/InputField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const AddDoctor = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const axiosPrivate = useAxiosPrivate();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    specialization: "",
    description: "",
    is_doctor: true,
    fees: "",
  });

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      placeholder: "Enter name",
      errorMessage: "Name shouldn't include any special character!",
      label: "Name",
      pattern: "^[A-Za-z ]{3,50}$",
      required: true,
    },
    {
      id: 2,
      name: "email",
      type: "email",
      placeholder: "Enter email",
      errorMessage: "Enter a valid email address!",
      label: "Email",
      required: true,
    },
    {
      id: 3,
      name: "password",
      type: "password",
      placeholder: "Enter password",
      errorMessage:
        "Password should be 8-20 characters and include at least 1 letter, 1 number and 1 special character!",
      label: "Password",
      pattern: `^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
    {
      id: 4,
      name: "specialization",
      type: "text",
      placeholder: "Enter specialization",
      errorMessage: "Specialization shouldn't include any special character!",
      label: "Specialization",
      pattern: "^[A-Za-z ]{3,50}$",
      required: true,
    }
  ];

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    type === "checkbox"
      ? setValues({ ...values, [name]: checked })
      : setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      await axiosPrivate.post("user/doctor/", 
      {
        "specialization": values.specialization,
        "description": values.description,
        "fees": values.fees,
        "user_detail": {
            "name": values.name,
            "email": values.email,
            "password": values.password
    }
      });
      navigate("/doctor/list", {
        state: {
          message: "Doctor has been added.",
          type: "success",
        },
      });
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert("Account is already registered with this email.", "warning");
      } else {
        showAlert("Registration Failed", "warning");
      }
    }
  };
  return (
    <div>
      <AlertField alert={alert} />

      <div className="d-flex justify-content-center mt-5">
        <div className="p-5 bg-light border rounded-3 w-50">
          <h1 className="text-center pb-3">Register Doctor</h1>

          <form onSubmit={handleSubmit}>
            {inputs.map((input) => (
              <InputField
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
            <label>Description</label> <br />
            <textarea className="w-100 p-2 mb-2" name="description" onChange={onChange} placeholder="Enter description" maxLength="200"/>
            <div className="d-flex align-items-end">
              <div>
                
            <label>Fees</label> <br />
            <input className="w-5 p-2 mb-2" type="number" name="fees" onChange={onChange} placeholder="Enter fees"/>
              </div>
            <div className="form-check mb-3 mx-5 d-none">
              <input
                className="form-check-input"
                type="checkbox"
                onChange={onChange}
                id="flexCheckChecked"
                name="is_doctor"
                checked={values.is_doctor}
                disabled
              />
              <h5 className="form-check-label m-0" htmlFor="flexCheckChecked">
                Doctor
              </h5>
            </div>
            </div>
            
            <div className="text-center mt-2">
              <button className="btn btn-primary m-2 py-2 px-5">
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddDoctor;
